import { render, staticRenderFns } from "./InventoryConsignmentAgreementAction.vue?vue&type=template&id=828f7158&scoped=true"
import script from "./InventoryConsignmentAgreementAction.vue?vue&type=script&lang=js"
export * from "./InventoryConsignmentAgreementAction.vue?vue&type=script&lang=js"
import "./InventoryConsignmentAgreementAction.vue?vue&type=style&index=0&id=828f7158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f7158",
  null
  
)

export default component.exports